import { Directive, Input, OnDestroy, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AddToWatchlist } from '../domain';
import { ToastMessageService } from '../../../notifications-toast/toast-message/toast-message.service';

@Directive({
  selector: '[tdWbAddToWatchlistToastMessage]'
})
export class AddToWatchlistToastMessageDirective implements OnDestroy, AfterViewInit {
  @Input('tdWbAddToWatchlistToastMessage') messageKey: string;

  private updateSubscription: Subscription;

  constructor(private addToWatchlistComponent: AddToWatchlist,
              private toastMessageService: ToastMessageService) {
  }

  ngAfterViewInit(): void {
    this.updateSubscription = this.addToWatchlistComponent.symbolAdded
      .subscribe((): void => {
        this.toastMessageService.setToast(this.messageKey);
      });
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }
}
